const style = {
  cursor: "pointer",
  border: "solid 1px #E0E0E0",
  borderRadius: 10,
  padding: 9,
  flexGrow: 1,
  maxWidth: 200,
  maxHeight: 300
};

export function AnimeImage(props) {
  return (<>
    <img style={ style } alt={ props.alt } src={ props.src }/>
  </>);
}
